
import React, { Component } from 'react'
import { connect } from 'react-redux'

import MissionChoicer from './MissionChoicer'

import { envConstants } from '../../constants'

import { generateMission, generateMissionSuccess, generateMissionFailure } from '../../actions'
import { holeHelper } from '../../helpers'

const initialState = {
  missions: null,
  lotId: null,
  showMe: false,
  showMissionsChoicer: false
}

class Missions extends Component {
  constructor () {
    super()
    this.escFunction = this.escFunction.bind(this)
    this.showMissions = this.showMissions.bind(this)
    this.state = initialState
  }

  escFunction (event) {
    switch (event.keyCode) {
      case 27:
        this.showMissions(true)
        break
      default:
        break
    }
  }

  generateMissions () {
    this.setState({ missions: null }, () => {
      this.props.generateMission()
    })
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        let holes = []
        this.props.dashboard.list.forEach((h) => {
          holes.push({
            lat: h.latitude,
            lng: h.longitude,
            dst: holeHelper.calculateDistance(
              position.coords.latitude,
              position.coords.longitude,
              h.latitude,
              h.longitude
            )
          })
        })
        holes = holes.sort((a, b) => (a.dst > b.dst) ? 1 : -1)
        const mls = {
          lot: this.state.lotId,
          holes
        }
        window.localStorage.setItem(envConstants.ls.missions, JSON.stringify(mls))
        this.setState({ missions: mls }, () => {
          this.props.generateMissionSuccess()
        })
      }, (error) => {
        this.props.generateMissionFailure(error.message)
      })
    } else {
      this.props.generateMissionFailure('Geolocalizzazione non disponibile')
    }
  }

  showMissions (force = false) {
    this.setState({ showMissionsChoicer: (!force ? !this.state.showMissionsChoicer : !force) })
  }

  componentDidMount () {
    const lsf = window.localStorage.getItem(envConstants.ls.dashboard_form)
    if (lsf) {
      const lls = JSON.parse(lsf)
      if (lls.formFilters.filter(x => x.type === 'lot').length) {
        const flt = lls.formFilters[0]
        const lsm = window.localStorage.getItem(envConstants.ls.missions)
        let missions = null
        if (lsm) {
          const llm = JSON.parse(lsm)
          if (llm.lot === parseInt(flt.value) && llm.holes.length === this.props.dashboard.list.length) {
            missions = llm
          }
        }
        this.setState({ showMe: true, lotId: parseInt(flt.value), missions })
      }
    }

    document.addEventListener('keydown', this.escFunction, false)
  }

  componentWillUnmount () {
    document.removeEventListener('keydown', this.escFunction, false)
  }

  render () {
    const s = this.state
    if (!s.showMe) {
      return (
      <></>
      )
    } else {
      return (
        <>
          {
            s.missions && (
              <button className="lnk-gen-missions-choicer" onClick={() => this.showMissions()}>
                <i className="fas fa-route"></i>
              </button>
            )
          }
          <button className="lnk-gen-missions" onClick={() => this.generateMissions()}>
            <i className="fas fa-plane-departure"></i>
          </button>
          {
            s.showMissionsChoicer && (
              <MissionChoicer missions={s.missions} showMissions={this.showMissions} />
            )
          }
        </>
      )
    }
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { generateMission, generateMissionSuccess, generateMissionFailure })(Missions)
